<template functional>
    <div class="row base-attribute-display">
        <div
            class="col-md-5 col-lg-4 col-xl-3 base-attribute-label text-left text-md-right"
        >
            {{ props.label }}
        </div>
        <div 
            class="col-md-7 col-lg-8 col-xl-9 base-attribute-value"
        >
            <slot>
            {{ props.value }}
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    functional: true,
    name: 'BaseAttrDisplayText',
    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: [String, Number],
            required: false,
        },
    },
}
</script>

<style>
.base-attribute-display {
    margin-bottom: 1rem;
    align-items: start;
}
.base-attribute-display .base-attribute-label {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 0.8rem;
    color: var(--secondary);
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
.base-attribute-display .base-attribute-value {
    font-weight: normal;
}
</style>